import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ENVIRONMENT_SETTINGS } from '@reconcept-platform/env';
import { WebSessionService } from '@reconcept-platform/shared/authentication';
import { ModalWindowController } from '@reconcept-platform/shared/ui/core/modal';
import { ButtonComponent, ButtonContainerComponent } from '@reconcept-platform/shared/ui/standalone/button';
import {
  ModalContentComponent,
  ModalFooterComponent,
  ModalHeaderComponent,
} from '@reconcept-platform/shared/ui/standalone/modal';

@Component({
  template: `
    <rcp-modal-header [title]="'qz-session-expired-zm' | translate" [showCloseButton]="false"></rcp-modal-header>

    <rcp-modal-content>
      <section>
        <p>{{ 'qz-session-expired-description-zm' | translate }}</p>
      </section>
    </rcp-modal-content>

    <rcp-modal-footer>
      <rcp-button-container align="center">
        <rcp-button color="primary" (click)="logout()"> {{ 'qz-relogin-zm' | translate }}</rcp-button>
      </rcp-button-container>
    </rcp-modal-footer>
  `,
  imports: [
    ModalHeaderComponent,
    ModalFooterComponent,
    ButtonComponent,
    TranslatePipe,
    ModalContentComponent,
    ButtonContainerComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SessionExpiredModalComponent {
  private webSessionService = inject(WebSessionService);
  private modalWindowController = inject(ModalWindowController);
  private environment = inject(ENVIRONMENT_SETTINGS);

  // can't use input() here, since we write to the properties directly when opening modals, instead of setting Inputs
  @Input() noCurrentSession: boolean;
  @Input() otherUser: boolean;

  logout() {
    if (this.noCurrentSession) {
      this.webSessionService.logout();
      this.modalWindowController.dismiss();
    } else {
      window.location.href = this.environment.authAppURL;
    }
  }

  close() {
    window.close();
  }
}
